import { render } from "./NotFoundComponent.vue?vue&type=template&id=4ad91d8c"
const script = {}

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/max-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__